export default {
    id: 'blue',
    colors: ['#0044A3', '#8CCBFF'],
};
